var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtilizedBudgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#FEF3F2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F04438",
    fillRule: "evenodd",
    d: "M12.871 12H23.13c.395 0 .736 0 1.017.023.297.024.592.078.875.222.424.216.768.56.984.984.144.283.198.578.222.875.023.28.023.622.023 1.017V18a.75.75 0 0 1-1.5 0v-.75h-13.5v3.6c0 .432 0 .712.018.924.017.204.045.28.064.316a.751.751 0 0 0 .327.328c.038.02.113.047.317.064.212.017.492.018.924.018H18a.75.75 0 0 1 0 1.5h-5.129c-.395 0-.736 0-1.017-.023a2.29 2.29 0 0 1-.875-.222 2.25 2.25 0 0 1-.984-.983 2.304 2.304 0 0 1-.222-.876c-.023-.28-.023-.622-.023-1.017V15.12c0-.395 0-.736.023-1.017a2.29 2.29 0 0 1 .222-.875 2.25 2.25 0 0 1 .984-.984 2.29 2.29 0 0 1 .875-.222c.28-.023.622-.023 1.017-.023Zm-1.621 3.75h13.5v-.6c0-.432 0-.712-.018-.924-.017-.204-.045-.28-.064-.317a.75.75 0 0 0-.328-.327c-.037-.02-.112-.047-.316-.064a12.796 12.796 0 0 0-.924-.018H12.9c-.432 0-.712 0-.924.018-.204.017-.28.045-.317.064a.751.751 0 0 0-.327.327c-.02.038-.047.113-.064.317-.017.212-.018.492-.018.924v.6Zm12 3.75a.75.75 0 0 1 .75.75v2.69l.97-.97a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l.97.97v-2.69a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilizedBudgt);
export default __webpack_public_path__ + "static/media/utilized-budgt.7e24d62ee403309a2ad5cb382ed7229a.svg";
export { ForwardRef as ReactComponent };